import { render, staticRenderFns } from "./newSparepartPOS.vue?vue&type=template&id=29a87787&scoped=true"
import script from "./newSparepartPOS.vue?vue&type=script&lang=js"
export * from "./newSparepartPOS.vue?vue&type=script&lang=js"
import style0 from "./newSparepartPOS.vue?vue&type=style&index=0&id=29a87787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a87787",
  null
  
)

export default component.exports